<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { Pause, Play } from 'lucide-vue-next'
import step1 from '../../assets/img/mandadito-step-1.webp'
import step2 from '../../assets/img/mandadito-step-2.webp'
import step3 from '../../assets/img/mandadito-step-3.webp'
import step4 from '../../assets/img/mandadito-step-4.webp'

const screens = [
  { src: step1, label: 'Origen', alt: 'Paso 1: elegir el punto de recogida del mandadito' },
  { src: step2, label: 'Destino', alt: 'Paso 2: elegir el punto de entrega del mandadito' },
  { src: step3, label: 'Paquete', alt: 'Paso 3: describir el paquete y elegir el vehículo' },
  { src: step4, label: 'Confirmar', alt: 'Paso 4: revisar y confirmar el mandadito' }
]

const active = ref(0)
const playing = ref(true)
const canAnimate = ref(false)
let timer = null

const stopTimer = () => {
  if (timer) {
    clearInterval(timer)
    timer = null
  }
}

const startTimer = () => {
  stopTimer()
  if (!canAnimate.value || !playing.value) return
  timer = setInterval(() => {
    active.value = (active.value + 1) % screens.length
  }, 4500)
}

const togglePlay = () => {
  playing.value = !playing.value
  if (playing.value) startTimer()
  else stopTimer()
}

const pause = () => stopTimer()
const resume = () => {
  if (playing.value) startTimer()
}

onMounted(() => {
  canAnimate.value = !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  if (canAnimate.value) startTimer()
})

onUnmounted(stopTimer)
</script>

<template>
  <div
    class="relative mx-auto w-full max-w-[280px]"
    @mouseenter="pause"
    @mouseleave="resume"
    @focusin="pause"
    @focusout="resume"
  >
    <div class="pointer-events-none absolute -inset-8 rounded-[3.5rem] bg-[#0a1120]/20 blur-3xl"></div>

    <div class="relative rounded-[2.7rem] border border-white/25 bg-[#0a1120] p-1.5 shadow-[0_35px_90px_rgba(10,17,32,0.45)]">
      <div class="relative aspect-[620/1379] overflow-hidden rounded-[2.2rem] bg-[#f4f6f9]">
        <div
          v-for="(screen, index) in screens"
          :key="screen.label"
          class="absolute inset-0 transition-opacity duration-700 ease-in-out"
          :class="active === index ? 'opacity-100' : 'opacity-0'"
          :aria-hidden="active !== index"
        >
          <img
            :src="screen.src"
            :alt="active === index ? screen.alt : ''"
            class="h-full w-full object-cover"
            loading="lazy"
            decoding="async"
          >
        </div>
      </div>
    </div>

    <button
      v-if="canAnimate"
      type="button"
      class="absolute -right-3 bottom-6 flex h-9 w-9 items-center justify-center rounded-full border border-white/15 bg-[#0a1120]/90 text-white shadow-lg backdrop-blur transition-colors hover:border-[#f0611e]/50 hover:bg-[#1c2b42]"
      :aria-label="playing ? 'Pausar la animación de la app' : 'Reanudar la animación de la app'"
      @click="togglePlay"
    >
      <Pause v-if="playing" :size="14" />
      <Play v-else :size="14" />
    </button>
  </div>
</template>
